export const environment = {
  production: true,
   api_url: 'https://backend.dev.azure.sahbak.co.il',
   SITE_URL: 'https://frontend.dev.azure.sahbak.co.il',
  endpoint: '/v2/api/employer',
  cloud_url: 'https://api.cloudinary.com/v1_1/hljdjmqlh/auto/upload',
  cloud_preset: 'vkeqnkeo',
};
